import React from 'react';
import './Plasticcompo.css';

// ✅ Apni actual image paths lagao
import medicalImg from '../../../imgs/Medicalprod.webp';
import gearsImg from '../../../imgs/Precisiong.webp';
import plateImg from '../../../imgs/Lightg.webp';
import lensImg from '../../../imgs/Opticall.webp';
import plasticImg from '../../../imgs/Plasticc.webp';

const appData = [
  { title: 'Medical Products', img: medicalImg },
  { title: 'Precision Gears', img: gearsImg },
  { title: 'Light Guide Plate', img: plateImg },
  { title: 'Optical Lens', img: lensImg },
  { title: 'Plastic Components', img: plasticImg },
];

const Plasticcompo = () => {
  return (
    <div className="applications-container">
      <h2>APPLICATIONS</h2>
      <div className="application-cards">
        {appData.map((item, index) => (
          <div className="application-card" key={index} data-aos="flip-left">
            <img src={item.img} alt={item.title} />
            <h3>{item.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plasticcompo;
